import ninegrid from "../index.js";

class nxSideMenu extends HTMLElement
{
	#minWidth;
	#maxWidth;
	
	constructor () {
		super();
		
		this.attachShadow({ mode: 'open' });
	};
			
	connectedCallback() {
		ninegrid.waitForInnerHTML(this)
			.then(() => this.#init())
			.catch(error => console.error(error));

		setTimeout(() => {
			if (!ninegrid.querySelector("nx-side-menu-item.active", this.shadowRoot)) {
				const rawUrl = window.location.href;         // 전체 URL
				const parsedUrl = new URL(rawUrl);           // URL 객체로 파싱
				const href = parsedUrl.pathname;        // 👉 경로만 추출

				const el = ninegrid.querySelector(`nx-side-menu-item[href="${href}"]`, this.shadowRoot);
				if (el) {
					el.classList.add("active");
				}
			}
		}, 300);

	};
	
	expand = () => {
		this.#removeClass("collapse");
		document.body.style.width = `calc(100% - ${this.#maxWidth}px)`;
	};
	
	collapse = () => {
		this.#addClass("collapse");
		document.body.style.width = `calc(100% - ${this.#minWidth}px)`;
		
		this.shadowRoot.host.style.width = 'var(--min-width)';
		setTimeout(() => {
			this.shadowRoot.host.style.width = '';
		}, 300);
	};
	
	#querySelectorBody = (selector) => {

		const body = this.shadowRoot.querySelector("nx-side-menu-body");
		return body ? body.shadowRoot.querySelectorAll(selector) : [];
	}
	
	#addClass = (className) => {
		this.classList.add(className);
		
		this.shadowRoot.querySelectorAll("nx-side-menu-head,nx-side-menu-foot,nx-side-menu-body,nx-side-menu-custom").forEach(el => {
			el.classList.add(className);
		});
		
		this.#querySelectorBody("nx-side-menu-item").forEach(el => {
			el.classList.add(className);
		});
	}
	#removeClass = (className) => {
		this.classList.remove(className);
		
		this.shadowRoot.querySelectorAll("nx-side-menu-head,nx-side-menu-foot,nx-side-menu-body,nx-side-menu-custom").forEach(el => {
			el.classList.remove(className);
		});
		
		this.#querySelectorBody("nx-side-menu-item").forEach(el => {
			el.classList.remove(className);
		});
	}
	
	#init = () => {
		
		//console.log(this.innerHTML);
		
		const contents	= this.innerHTML.trim();
		this.innerHTML = "";
		
		this.#minWidth = Number(this.getAttribute("min-width") || 48);
		this.#maxWidth = Number(this.getAttribute("max-width") || 256);

		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSideMenu.css";
				${ninegrid.getCustomPath(this,"nxSideMenu.css")}
				
				:host {
					--min-width: ${this.#minWidth}px;
					--max-width: ${this.#maxWidth}px;
					
					display: flex;
					flex-direction: column;
				}
			</style>
			
			${contents}
		`;
		
		this.addEventListener('mouseover', e => {
			this.#addClass("hover");
		});
		
		this.addEventListener('mouseout', e => {
			this.#removeClass("hover");
		});

		
		document.body.style.float = 'right';
		document.body.style.transition = 'width 0.5s ease-in-out';
		
		this.collapse();
		
		//console.log(this.#querySelectorBody("nx-side-menu-item.group"));
		/**
		this.#querySelectorBody("nx-side-menu-item.group").forEach(el => {
			
			console.log(el);
			
			el.addEventListener("click", e => {

				//console.log(e);				
				
				const nodeList = this.#querySelectorBody("nx-side-menu-item");
				const firstNodeIndex = Array.from(nodeList).findIndex(node => node.uuid === e.target.uuid);
				
				const childNode = [];
				
				if (firstNodeIndex !== -1) {
					
					// 첫 번째 노드부터 순차적으로 검색 
					for (let i = firstNodeIndex + 1; i < nodeList.length; i++) {
						
						const currentNode = nodeList[i];
						if (currentNode.classList.contains('group')) { break; }
						childNode.push(currentNode);
					}
				}
				
				el.classList.toggle("expand");
				
				if (el.classList.contains("expand")) {
					childNode.forEach(el => {
						el.classList.add("expand");
					});
				}
				else {
					childNode.forEach(el => {
						el.classList.remove("expand");
					});
				}
				
				
			});
		});	 */
	};
}




class nxSideMenuHead extends HTMLElement
{
	#owner;
	
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		ninegrid.waitForInnerHTML(this)
			.then(() => this.#init())
			.catch(error => console.error(error));
	}
	
	#init = () => {
		this.#render();
				
		this.#owner	= this.shadowRoot.getRootNode().host.getRootNode().host;
		if (!this.#owner) return;
		
		this.shadowRoot.querySelector('.icon:nth-of-type(1)').addEventListener('click', e => {
			this.#owner.expand();
		});
		
		this.shadowRoot.querySelectorAll('.icon:nth-of-type(2),.icon:nth-of-type(3)').forEach(icon => {
			icon.addEventListener('click', e => {
				this.#owner.collapse();
			});
		});
	}

	#render() {
		const iconColor = this.getAttribute("icon-color") || "#eee";
		const contents	= this.innerHTML.trim();
		
		this.innerHTML = "";
		
		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSideMenuHead.css";
				${ninegrid.getCustomPath(this,"nxSideMenuHead.css")}
				
				:host {
					--icon-color: ${iconColor};
				}
			</style>
			
			<div class="logo-box">
				${contents}
			</div>
	
			<div class="icon-box">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
				</svg>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
				</svg>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
				</svg>
			</div>
		`;
	}
}

class nxSideMenuFoot extends HTMLElement
{
	#owner;
	
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		ninegrid.waitForInnerHTML(this)
			.then(() => this.#init())
			.catch(error => console.error(error));
	}
	
	#init = () => {
		this.#owner	= this.closest("nx-side-menu");
				
		this.#render();
		
		this.shadowRoot.querySelector('.icon:nth-of-type(1)').addEventListener('click', () => {
			this.#owner.expand();
		});
		
		this.shadowRoot.querySelectorAll('.icon:nth-of-type(2), .icon:nth-of-type(3)').forEach(icon => {
			icon.addEventListener('click', e => {
				this.#owner.collapse();
			});
		});
	}

	#render() {
		const iconColor = this.getAttribute("icon-color") || "#eee";
		const contents	= this.innerHTML.trim();
		
		this.innerHTML = "";
		
		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSideMenuFoot.css";
				${ninegrid.getCustomPath(this,"nxSideMenuFoot.css")}
				
				:host {
					--icon-color: ${iconColor};
				}
			</style>
			
			<div class="logo-box">
				${contents}
			</div>
	
			<div class="icon-box">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
				</svg>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
				</svg>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="icon" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
				</svg>
			</div>
		`;
	}
}


class nxSideMenuBody extends HTMLElement
{
	#owner;
	
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		ninegrid.waitForInnerHTML(this)
			.then(() => this.#init())
			.catch(error => console.error(error));
	}
	
	#init = () => {
		this.render();
		this.#owner	= this.shadowRoot.getRootNode().host.getRootNode().host;
	};

	render() {
		const contents	= this.innerHTML.trim();
		
		this.innerHTML = "";
		
		this.shadowRoot.innerHTML = `
			<style>
				:host {
					height: 100%;
					display: flex;
					overflow: auto;
					justify-content: center;
				}
				ul.side-menu-body {
					width: 100%;
					padding: 0;
					margin: 0;
				    display: flex;
				    flex-direction: column;
				    --align-items: center;
				}
			</style>
			
			<ul class="side-menu-body">
				${contents}
			</ul>
		`;
	}
}

class nxSideMenuItem extends HTMLElement
{
	#caption;
	#owner;
	#type;
	
	constructor() {

		super();
		this.attachShadow({ mode: 'open' });

		this.test = this.innerText.trim();
		this.uuid = ninegrid.randomUUID();
	}

	connectedCallback() {
		this.#caption = this.getAttribute("title");//this.innerText.trim();

		//requestAnimationFrame(() => {


			//console.log("nxSideMenuItem", this.#caption);
			//this.data.caption = this.#caption;
			//this.setAttribute("data-caption", this.innerText.trim());
			//this.#init();


			ninegrid.waitForInnerHTML(this)
				.then(() => this.#init())
				.catch(error => console.error(error));
		//});

	}

	get caption() {
		return this.#caption;
	}
	
	#init = () => {

		this.#type		= this.getAttribute('type') || "item";
				
		this.render();
		
		
		this.#owner	= ninegrid.closest("nx-side-menu", this);
		
		this.classList.toggle("expand");
		this.classList.add("collapse");
		this.classList.add(this.#type);
		
		

		this.addEventListener('click', (e) => {
			
			ninegrid.querySelectorAll("nx-side-menu-item", this.#owner).forEach(v => {
				v.classList.remove("active");
			});
			
			e.target.classList.add("active");

			ninegrid.closest("nx-side-menu", this).dispatchEvent(new CustomEvent('side-menu-click', {
				detail: { target: this, },
				bubbles: true,
				composed: true
			}));
			
		});
		
		//console.log(this);
		
		const expandIcon = this.shadowRoot.querySelector(".expand-icon");
		//console.log(expandIcon);
		
		if (expandIcon) {
			expandIcon.addEventListener('click', (e) => {
				
			
				e.stopPropagation();
				
				//const target = neUtils.closest("nx-side-menu-item", this);
				//console.log(this.uuid);
				
				const nodeList = ninegrid.querySelectorAll("nx-side-menu-item", this.#owner);
				const firstNodeIndex = Array.from(nodeList).findIndex(node => node.uuid === this.uuid);
				const childNode = [];
				
				if (firstNodeIndex !== -1) {
					
					// 첫 번째 노드부터 순차적으로 검색 
					for (let i = firstNodeIndex + 1; i < nodeList.length; i++) {
						
						const currentNode = nodeList[i];
						if (currentNode.classList.contains('group')) { break; }
						childNode.push(currentNode);
					}
				}
				
				this.classList.toggle("expand");
				
				if (this.classList.contains("expand")) {
					childNode.forEach(el => {
						el.classList.remove("hide");
						//el.style.display = "";
					});
				}
				else {
					childNode.forEach(el => {
						el.classList.add("hide");
						//el.style.display = "none";
					});
				}
			});
		}
		
		
	};
	

	render() {
		
		const iconClass = this.getAttribute('icon-class');
		const contents	= this.innerHTML.trim();


		
		this.innerHTML = "";
		
		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxSideMenuItem.css";
				${ninegrid.getCustomPath(this,"nxSideMenuItem.css")}
			</style>
			
			<li>
				<div class="icon ${iconClass}"></div>
				<div class="menubar">
					${contents}
				</div>
				<div class="expand-icon"></div>
			</li>
		`;
	}
}

if (!customElements.get('nx-side-menu')) {
	customElements.define("nx-side-menu", nxSideMenu);
}

if (!customElements.get('nx-side-menu-head')) {
	customElements.define("nx-side-menu-head", nxSideMenuHead);
}

if (!customElements.get('nx-side-menu-foot')) {
	customElements.define("nx-side-menu-foot", nxSideMenuFoot);
}

if (!customElements.get('nx-side-menu-body')) {
	customElements.define("nx-side-menu-body", nxSideMenuBody);
}

if (!customElements.get('nx-side-menu-item')) {
	customElements.define("nx-side-menu-item", nxSideMenuItem);
}